import { SearchParamsSourceContextProvider } from '@aibees/shared/hooks';
import { useMemo, type PropsWithChildren } from 'react';
import { useSearchQueryFilterSetters } from '../../hooks/use-search-query-filter';

/**
 * Provides search params setters from the store to shared context (setters-only).
 * Params are provided by SearchParamsParamsProvider around the table so only the table
 * subtree re-renders when params change. Must be mounted inside SearchParamsUrlSync.
 */
export function SearchParamsSourceProvider({ children }: PropsWithChildren) {
  const { setParams, setParam, removeParam } = useSearchQueryFilterSetters();

  const value = useMemo(
    () => ({
      setParams,
      setParam,
      removeParam,
    }),
    [setParams, setParam, removeParam]
  );

  return (
    <SearchParamsSourceContextProvider value={value}>
      {children}
    </SearchParamsSourceContextProvider>
  );
}
